import store from '../store';
import { SITE_TITLE, SITE_SUBTITLE } from '../store/keys';

export default {
	computed: {
		siteTitle: () => store.getters[SITE_TITLE],
		siteSubtitle: () => store.getters[SITE_SUBTITLE]
	}
};
